import { HoneycombWebSDK } from "@honeycombio/opentelemetry-web";

export type HoneycombConfig = {
  ingestApiKey: string;
  serviceName: string;
  isDebug: boolean;
  active: boolean;
};

let honeycombSdk: HoneycombWebSDK | undefined;

export function initializeHoneycomb(config: HoneycombConfig) {
  honeycombSdk = new HoneycombWebSDK({
    debug: config.isDebug,
    apiKey: config.ingestApiKey,
    serviceName: config.serviceName,
    instrumentations: [],
  });
  if (config.active) {
    honeycombSdk.start();
  }
}

export async function flushHoneycomb(): Promise<void> {
  await honeycombSdk?.forceFlush();
}
